import React from "react";
import { SiteLink as Link } from "./site-link";
import { FaAppStoreIos, FaGooglePlay } from "react-icons/fa";
import { Social } from "../../data";
import { APP_STORE_URL, PLAY_STORE_URL, navLinks } from "../../constants/landing";

export function StoreButtons({ light = false }) {
  const cls = light
    ? "bg-white text-primary-dark hover:bg-secondary-light"
    : "bg-primary-dark text-white hover:bg-primary-light";
  const base = `inline-flex items-center gap-3 rounded-2xl px-5 py-3 transition ${cls}`;
  return (
    <div className="flex flex-wrap gap-3">
      <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className={base}>
        <FaAppStoreIos className="text-[26px]" />
        <span className="flex flex-col text-left leading-tight">
          <span className="text-[10px] opacity-80">Download on the</span>
          <span className="text-[15px] font-semibold">App Store</span>
        </span>
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" className={base}>
        <FaGooglePlay className="text-[22px]" />
        <span className="flex flex-col text-left leading-tight">
          <span className="text-[10px] opacity-80">Get it on</span>
          <span className="text-[15px] font-semibold">Google Play</span>
        </span>
      </a>
    </div>
  );
}

export default function LandingFooter() {
  return (
    <footer className="bg-primary-dark text-white">
      <div className="mx-auto grid w-[92%] max-w-[1200px] gap-12 py-16 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div className="space-y-5">
          <img src="/assets/images/logo2.png" alt="PrepaidMeter.ng" className="h-10 w-auto brightness-0 invert" />
          <p className="max-w-[420px] text-[15px] leading-relaxed text-white/70">
            Central vending for your community. Simple bill collection, smarter security with gate and
            visitor management.
          </p>
          <div className="flex items-center gap-5">
            {Social.map((s) => (
              <a key={s.path} href={s.path} target="_blank" rel="noreferrer">
                {s.icon}
              </a>
            ))}
          </div>
        </div>
        <div>
          <h6 className="mb-5 text-sm font-semibold uppercase tracking-wider text-white/50">Company</h6>
          <ul className="space-y-3 text-[15px]">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/80 hover:text-secondary-dark">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/buy-meter" className="text-white/80 hover:text-secondary-dark">Get a meter</Link>
            </li>
          </ul>
        </div>
        <div>
          <h6 className="mb-5 text-sm font-semibold uppercase tracking-wider text-white/50">Get the app</h6>
          <StoreButtons light />
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-sm text-white/50">
        © {new Date().getFullYear()} PrepaidMeter.ng. All rights reserved.
      </div>
    </footer>
  );
}
